import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";

const RadioDefaultIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <g clipPath="url(#clip0_3391_31556)">
        <mask id="path-1-inside-1_3391_31556" fill="white">
          <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" />
        </mask>
        <path
          d="M12 22.5C6.20101 22.5 1.5 17.799 1.5 12H-1.5C-1.5 19.4558 4.54416 25.5 12 25.5V22.5ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5V25.5C19.4558 25.5 25.5 19.4558 25.5 12H22.5ZM12 1.5C17.799 1.5 22.5 6.20101 22.5 12H25.5C25.5 4.54416 19.4558 -1.5 12 -1.5V1.5ZM12 -1.5C4.54416 -1.5 -1.5 4.54416 -1.5 12H1.5C1.5 6.20101 6.20101 1.5 12 1.5V-1.5Z"
          fill="currentColor"
          mask="url(#path-1-inside-1_3391_31556)"
        />
        <g clipPath="url(#clip1_3391_31556)">
          <mask id="path-3-inside-2_3391_31556" fill="white">
            <path d="M5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z" />
          </mask>
          <path
            d="M5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z"
            fill="currentColor"
          />
          <path
            d="M12 18.125C8.61726 18.125 5.875 15.3827 5.875 12H4.125C4.125 16.3492 7.65076 19.875 12 19.875V18.125ZM18.125 12C18.125 15.3827 15.3827 18.125 12 18.125V19.875C16.3492 19.875 19.875 16.3492 19.875 12H18.125ZM12 5.875C15.3827 5.875 18.125 8.61726 18.125 12H19.875C19.875 7.65076 16.3492 4.125 12 4.125V5.875ZM12 4.125C7.65076 4.125 4.125 7.65076 4.125 12H5.875C5.875 8.61726 8.61726 5.875 12 5.875V4.125Z"
            fill="currentColor"
            mask="url(#path-3-inside-2_3391_31556)"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3391_31556">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_3391_31556">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default RadioDefaultIcon;
